<template>
  <v-dialog
    v-model="dialog"
    max-width="360"
    persistent
  >
    <v-form
      v-model="valid"
      lazy-validation
    >
      <v-toolbar
        dense
        light
        class="grey lighten-2"
      >
        <v-toolbar-title class="text-body-1 font-weight-bold">
          {{ $t('m.addPort') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          color=""
          @click="handleCancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card
        tile
        flat
      >
        <v-card-text>
          <v-container class="pa-0">
            <v-autocomplete
              v-model="portSelect"
              dense
              hide-details="true"
              :label="$t('m.port')"
              outlined
              clearable
              :items="portItems"
              :loading="isLoadingPort"
              :search-input.sync="portSearch"
              hide-no-data
              cache-items
              item-text="FULLNAME"
              item-value="PORTID"
              return-object
              class="mb-2"
            />

            <v-select
              v-model="portAddForm.taskType"
              value
              dense
              hide-details="true"
              outlined
              item-text="label"
              item-value="value"
              :items="taskTypeArr"
              :label="$t('m.taskTypeName')"
              class="mb-2"
            />

            <v-select
              v-model="portAddForm.targetPortPos"
              dense
              hide-details="true"
              outlined
              item-text="name"
              item-value="portSeq"
              :items="targetPortArr"
              :label="$t('m.addPortTo')"
              class="mb-2"
            />

            <v-select
              v-model="portAddForm.posType"
              dense
              hide-details="true"
              outlined
              item-text="label"
              item-value="value"
              :items="posArr"
              :label="$t('m.addPortPosition')"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            small
            color="blue darken-1"
            text
            @click="handleCancel"
          >
            {{ $t('m.cancel') }}
          </v-btn>
          <v-btn
            small
            :disabled="portAddBtnDisabled"
            color="blue darken-1"
            @click="handleAddPort"
          >
            {{ $t('m.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'

export default {
  name: 'PortAddDlg',
  components: { },
  props: [
    'visible',
    'targetPortArr'
  ],
  data () {
    return {
      dialog: false,
      valid: false,
      portSelect: null,
      portSearch: null,
      portItems: [],
      isLoadingPort: false,

      posArr: [
        { label: this.$t('m.portPosTop'), value: '1' },
        { label: this.$t('m.portPosBottom'), value: '2' }
      ],
      taskTypeArr: [],

      portAddForm: {
        portId: '',
        portName: '',
        fullName: '',
        longitude: '',
        latitude: '',
        taskType: '',
        targetPortPos: '',
        posType: '1' // 1 - 上方  2 - 下方
      },
      portAddBtnDisabled: true
    }
  },
  created () {
    Constant.TASK_TYPE_ARR.forEach((ele, index) => {
      var myObj = {
        label: this.$t('m.task' + this._.capitalize(ele.label)),
        value: ele.value
      }
      this.taskTypeArr.push(myObj)
    })
  },
  computed: {
    ...mapState({
      isRotating: state => state.estimating.isRotating,
      isGettedDistance: state => state.estimating.isGettedDistance
    })
  },
  watch: {
    visible: function (val) {
      this.dialog = val
      this.handleClear()
    },

    portSelect (val) {
      if (!val) return
      var postJson = {
        OperID: Utils.getWithExpiry('operID'),
        PortName: val.PORTNAME
      }
      httpClient.post('/SPPortSuggestQry', postJson)
        .then((res) => {
          const obj = res.data.find((p) => p.PORTID === val.PORTID)

          this.portAddForm.portId = obj.PORTID
          this.portAddForm.portName = obj.FULLNAME.split(',')[0]
          this.portAddForm.fullName = obj.FULLNAME
          this.portAddForm.longitude = Number(obj.LONGITUDE)
          this.portAddForm.latitude = Number(obj.LATITUDE)
        }).catch((err) => {

        })
    },

    portSearch (val) {
      if (!val || this.isLoadingPort) return
      if (val.trim().length < 2) {
        return
      }
      this.isLoadingPort = true
      var postJson = {
        OperID: Utils.getWithExpiry('operID'),
        PortName: val
      }
      httpClient.post('/PortSuggest4API', postJson)
        .then((res) => {
          this.isLoadingPort = false
          this.portItems = res.data
        }).catch((err) => {
          this.isLoadingPort = false
        })
    },

    'portAddForm.portId': function (val) {
      this.handlePortAddFormWatcher()
    },
    'portAddForm.taskType': function (val) {
      this.handlePortAddFormWatcher()
    },
    'portAddForm.targetPortPos': function (val) {
      this.handlePortAddFormWatcher()
    }
  },
  methods: {
    handleClearPort () {
      this.portSelect = null
      this.portSearch = null
      this.portItems = []

      this.portAddForm.portId = ''
      this.portAddForm.portName = ''
      this.portAddForm.fullName = ''
      this.portAddForm.longitude = ''
      this.portAddForm.latitude = ''
    },

    handleClear () {
      this.handleClearPort()
      this.portAddForm.taskType = ''
      this.portAddForm.targetPortPos = ''
      this.portAddForm.posType = '1'
    },

    handlePortAddFormWatcher () {
      if (this.portAddForm.portId.length > 0 &&
            this.portAddForm.taskType !== '' &&
            (this.portAddForm.targetPortPos !== '' || this.isTerm === true)) {
        this.portAddBtnDisabled = false
      } else {
        this.portAddBtnDisabled = true
      }
    },

    handleAddPort () {
      this.$emit('save', this._.clone(this.portAddForm))
    },

    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>
